import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=15ee011d"
import script from "./dashboard.vue?vue&type=script&lang=js"
export * from "./dashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15ee011d')) {
      api.createRecord('15ee011d', component.options)
    } else {
      api.reload('15ee011d', component.options)
    }
    module.hot.accept("./dashboard.vue?vue&type=template&id=15ee011d", function () {
      api.rerender('15ee011d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/smart-analytics/dashboard.vue"
export default component.exports